import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  entidade: [],
  marketplace_name: [],
  origem: [],
  natureza: [],
  dtemissao: {
    i: null,
    f: null,
  },
  valor: '',
  valor_baixado: '',
  valor_pendente: '',
  filial: [],
  documento: '',
  observacao: '',
};

export const HaveresPendentesContext = createContext();

export const HaveresPendentesProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [haveresPendentes, setHaveresPendentes] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getHaveresPendentes = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: haveresPendentes?.filter,
        page: haveresPendentes?.page,
        size: haveresPendentes?.size,
        order: haveresPendentes?.order,
        ...payload,
      });
      setHaveresPendentes((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <HaveresPendentesContext.Provider
      value={{
        getLoading,
        getHaveresPendentes,
        haveresPendentes,
      }}
    >
      {children}
    </HaveresPendentesContext.Provider>
  );
};
